import { EventEmitter, Inject, Injector, Input, OnChanges, Output, SimpleChanges, Directive } from '@angular/core';
import { AreaModel } from '../area.model';
import { IAreaToDeleteData } from './area-to-delete-data.model';
import { AreaDeleteCardBase } from './area-delete-card-base';
import { areaDeleteIsItemToUnShare } from './area-delete-utils';

@Directive()
export abstract class AreaDeleteOptionsCardBase extends AreaDeleteCardBase implements OnChanges {
    @Input() option;
    @Output('optionChange') optionChangeEmitter = new EventEmitter();

    optionOnChange() {
        this.optionChangeEmitter.emit(this.option);
    }

    @Input() area: AreaModel;
    @Input() areaToDeleteData: IAreaToDeleteData;

    summaryText: string = '';

    constructor(@Inject(Injector) injector: Injector) {
        super(injector);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.areaToDeleteData) {
            this.updateSummaryText();
        }
    }

    itemsToDelete: Array<any> = [];
    itemsToUnShare: Array<any> = [];

    updateSummaryText() {
        const toDelete = [],
            toUnShare = [];
        this.itemsToDelete = [];
        this.itemsToUnShare = [];
        const items = this.getItemsToDelete();
        items.forEach((item) => {
            const result =
                '<span class="BrandedColor">' +
                item.Count +
                ' ' +
                this.objectTypes.GetNameByObjectType(item.ObjectType, item.Count > 1) +
                '</span>';
            if (areaDeleteIsItemToUnShare(item)) {
                toUnShare.push(result);
                this.itemsToUnShare.push(item);
            } else {
                toDelete.push(result);
                this.itemsToDelete.push(item);
            }
        });

        this.summaryText = this.getSummaryText(toDelete, toUnShare);
    }

    abstract getItemsToDelete(): any[];

    getSummaryText(toDelete, toUnShare) {
        const result = [];
        if (toDelete.length > 0) {
            result.push(
                this.appTextService.get('area_delete.will_be_deleted', {
                    '{items}': this.joinSummaryGroup(toDelete),
                    '{area_to_delete}': this.area.Name,
                }),
            );
        }
        if (toUnShare.length > 0) {
            result.push(
                this.appTextService.get('area_delete.will_be_unshared', {
                    '{items}': this.joinSummaryGroup(toUnShare),
                    '{area_to_delete}': this.area.Name,
                }),
            );
        }
        return result.join(' ');
    }
}
